import type { BlogQueryStringInputType, BlogView } from "@lexicon/models";

import { parseBlogView } from "@lexicon/models";

import useQuery from "src/hooks/query/useQuery";
import lexiconAuthenticatedClient from "src/utility/lexiconAuthenticatedClient";
import queryKeys from "src/utility/query/queryKeys";

function useBlogQuery(blogId: string, params?: BlogQueryStringInputType) {
  return useQuery<BlogView>({
    queryKey: queryKeys.blogs({ blogId }, params),
    queryFn: async () => {
      const { data } = await lexiconAuthenticatedClient.get(`/api/v1/blogs/${blogId}`, { params });
      return parseBlogView(data.blog);
    },
  });
}

export default useBlogQuery;
